import { customElement } from 'lit/decorators.js';
import { TefComsButton } from '@src/components/TefComsButton.js';
import { componentStateStore, consentStore } from '@src/store/index.js';

@customElement('tef-coms-cancel-button')
export class TefComsCancelButton extends TefComsButton {
  variant: string = 'plain';

  override render() {
    return this.getTemplateFn('tefComsCancelButton')(this.variant);
  }

  handleClick() {
    componentStateStore.reset();
    consentStore.actualConsents = structuredClone(consentStore.initialConsents);
  }
}
